/**
 * VP company identity for the foreman apps, shared by web and NativeScript.
 *
 * This file exists to CONVERGE a documented duplicate. `MSI_VP_COMPANY_ID = 47` was
 * declared twice in `web-sparta`, once in the Individual Time Entry feature and once in
 * Time Manager (`foreman-add-entry-dialog.utils.ts`). The Time Manager copy carried the
 * instruction verbatim: "duplicated as a constant in the Individual Time Entry feature
 * (PR #30054). Converge both onto one shared foreman util once both merge, kept separate
 * here because each rides an independent branch off main." Both have merged, so the
 * stated precondition is met.
 */

/**
 * VP company number for Mechanical Solutions (MSI).
 *
 * Single source of truth. Two independent business rules key off it, and they are
 * DELIBERATELY NOT collapsed into one function (see below).
 */
export const MSI_VP_COMPANY_ID = 47;

/**
 * Whether the given VP company is MSI (Co 47). False for null/undefined.
 *
 * This is the PRIMITIVE only. Each feature keeps its own named wrapper expressing its own
 * rule, because the rules are unrelated and merely happen to share a predicate today:
 * Individual Time Entry hides Per Diem/Materials/Tasks, Time Manager suppresses the
 * "not dispatched" warning. Collapsing them would couple two business rules so that
 * changing one silently changes the other.
 *
 * Fails open (returns false) on an unknown company id, so a not-yet-loaded profile never
 * applies an MSI-only restriction to a non-MSI user.
 */
export function isMsiCompany(vpCompanyId: number | null | undefined): boolean {
  return vpCompanyId === MSI_VP_COMPANY_ID;
}
